import { render, staticRenderFns } from "./DashboardInnerView.vue?vue&type=template&id=016208e4&"
import script from "./DashboardInnerView.vue?vue&type=script&lang=js&"
export * from "./DashboardInnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports